<template>
  <div class="swap-table mt-2">
    <div class="swap-table__row">
      <div class="swap-table__label">{{ $t('burn.youSent') }}</div>
      <div class="swap-table__value">
        <div>{{ lpAmount.formatted.value }} {{ $t('common.lp') }}</div>
      </div>
    </div>
    <div class="swap-table__row is-small">
      <div class="swap-table__label">{{ $t('burn.minimumReceived') }}</div>
      <div class="swap-table__value">
        <span v-if="burnStore.isUpdatingRate"
          ><i class="pi pi-spin pi-spinner" style="font-size: 12px"
        /></span>
        <template v-else-if="!isSoloPool">
          <div>{{ firstAmount.formatted.value }}</div>
          <div>{{ secondAmount.formatted.value }}</div>
        </template>
        <template v-else>
          <div>{{ soloOutput.formatted.value }}</div>
        </template>
      </div>
    </div>
  </div>

  <div
    class="swap-help"
    v-html="
      $t(
        'burn.youWillReceive',
        isSoloPool
          ? {
              first: soloOutput.formatted.value,
              second: '',
            }
          : {
              first: firstAmount.formatted.value,
              second: secondAmount.formatted.value,
            },
      )
    "
  />
</template>

<script lang="ts" setup>
import { useBurnLiquidityStore } from '@/store';
import { computed, ref } from 'vue';
import { useCurrencyFormat } from '@/composables/useCurrencyFormat';
import { LP_DECIMALS } from '@/constants';

const burnStore = useBurnLiquidityStore();
const isSoloPool = ref(!!burnStore.pool?.depositToken);

const soloOutput = useCurrencyFormat(
  computed(() => burnStore.soloExpectedOutput.value),
  computed(() => burnStore.pool?.depositToken),
);

const firstAmount = useCurrencyFormat(
  computed(() => burnStore.output?.x),
  computed(() => burnStore.fromCurrency.token),
);
const secondAmount = useCurrencyFormat(
  computed(() => burnStore.output?.y),
  computed(() => burnStore.toCurrency.token),
);
const lpAmount = useCurrencyFormat(
  computed(() => burnStore.burnAmount),
  computed(() => burnStore.lpTokenName),
  { useSuffix: false, _decimals: LP_DECIMALS },
);
</script>

<style scoped lang="scss">
.pool-info {
  display: flex;
  align-items: center;

  font-weight: 500;
  color: var(--text-color);
  font-size: 15px;
  padding: 16px 8px;
}

.swap-table {
  border: 1px solid transparentize(#e5e4fa, 0.85);
  border-radius: 16px;

  &__row {
    padding: 12px 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--text-color);
    font-size: 17px;

    &.is-small {
      opacity: 0.7;
      font-size: 13px;
      font-weight: 500;
    }

    &:not(:last-child) {
      border-bottom: 1px solid transparentize(#e5e4fa, 0.85);
    }
  }

  &__label {
    width: 50%;
  }

  &__value {
    margin-left: auto;
  }
}

.swap-help {
  color: transparentize(#e5e4fa, 0.6);
  font-size: 13px;
  font-weight: 500;
  margin-top: 24px;
  padding: 0 16px;
  line-height: 18px;

  b {
    color: #e5e4fa;
    font-weight: 500;
  }
}
</style>
